/* eslint-disable react/prop-types */
import React from 'react'
import { withTranslation } from 'react-i18next'

import './ChallengeIndex.scss'

import ChallengeCard from '../subcomponents/ChallengeCard'

class ChallengeIndex extends React.Component {
  render() {
    const {
      challenges,
      handleMakeSelected,
      goToNew,
      leapfrogToDestroy,
      t,
    } = this.props
    return (
      <div id='ChallengeIndex'>
        <div className='new-challenge-button-container'>
          <button className='new-challenge-button' onClick={goToNew}>
            {t('challenges.index.newChallenge')}
          </button>
        </div>
        <div className='challenge-index-content-area'>
          {challenges.map(challenge => (
            <ChallengeCard
              key={challenge.id}
              challenge={challenge}
              onClick={handleMakeSelected}
              onDelete={leapfrogToDestroy}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default withTranslation()(ChallengeIndex)
